// extracted by mini-css-extract-plugin
module.exports = {"root":"Typography_root__ug0Gy","truncate":"Typography_truncate__Jm9E9"};